module.exports=function(scope){ return `# Call /match-3d-3d or /match-3d-2d based on data you are matching
# The source object must have EITHER an enrollmentIdentifier or faceMap parameter
# The target object must have EITHER an enrollmentIdentifier or faceMap or image parameter

var https = require("https");
data = JSON.stringify({
  "source": {"enrollmentIdentifier": INSERT_ENROLLMENT_IDENTIFIER_HERE},
  "target": {"faceMap": INSERT_FACEMAP_FROM_zoomSessionResult},
  "sessionId": INSERT_SESSION_ID_FROM_zoomSessionResult,
  "auditTrailImage": INSERT_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult,
  "lowQualityAuditTrailImage": INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult
})

callFaceTecAPI(data, "/api/v2/biometrics/match-3d-3d", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(data, path, callback){
  var options = {
    hostname: "api.zoomauth.com",
    port: 443,
    path: path,
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-Device-License-Key": "${scope.appToken}",
        "X-User-Agent": ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj.data)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.write(data)
  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/nodejs/compare.js.tpl